import { ROUTES } from '@shared/utils';
import { useTranslations } from 'next-intl';
import type { ComponentProps } from 'react';
import { InnerPageContainer } from '../../InnerPageContainer/InnerPageContainer';
import { Link as LinkComponent } from '../../Link/Link';
import { LoginButton } from '../../LoginButton/index';
import { PurchasesStateIcon } from '../PurchasesStateIcon/PurchasesStateIcon';

type PurchasesLoggedOutStateProps = ComponentProps<'div'> & {
  'data-testid'?: string;
};

function PurchasesLoggedOutState({ className, 'data-testid': dataTestId = 'purchases-logged-out-state', ...props }: PurchasesLoggedOutStateProps) {
  const t = useTranslations('lotteries.purchase.logged_out');

  return (
    <InnerPageContainer className={className} data-testid={dataTestId} {...props}>
      <div className="m-10 px-4 py-10 flex flex-col items-center gap-4 text-center" data-track-container="Open Bets">
        <PurchasesStateIcon tone="accent" />
        <p className="text-foreground-subtle max-w-75" data-testid="purchases-logged-out-message">
          {t('message')}
        </p>
        <LoginButton size="m" variant="accent" data-testid="purchases-login-cta" data-track-name="Log In">
          {t('cta')}
        </LoginButton>
        <p className="text-foreground-subtle max-w-75">
          <span>{t('join_prompt')}</span>
          <LinkComponent className="ml-1" href={ROUTES.REGISTER} data-track-name="Register">
            {t('join_cta')}
          </LinkComponent>
        </p>
      </div>
    </InnerPageContainer>
  );
}

export { PurchasesLoggedOutState };
